<template>
  <div class="index">
    <Seacher></Seacher>
    <div class="index_search">
      <div class="index_head">Search Result</div>
      <div class="index_content">
        <img src="../../assets/m/noseach.png" />
      </div>
    </div>
  </div>
</template>

<script>
import Seacher from "@/components/m/Seacher.vue";
export default {
  components: {
    Seacher,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>

<style lang="less" scoped>
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
.scale {
}
.scale :hover {
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari Chrome */
  -o-transform: rotate(7deg); /* Opera */
  color: red;
}

.index {
  width: 750px;
  height: 100vh;
  margin: 110px auto 0px auto;
  background: #000;
  text-align: center;
  padding-bottom: 80px;

  .index_search {
    width: 686px;
    height: 86%;
    background: #13161b;
    border-radius: 16px 16px 16px 16px;
    margin: 0 auto;
    opacity: 1;
    margin-top: 32px;
    .index_head {
      width: 686px;
      height: 80px;
      opacity: 1;
      text-align: left;
      margin-left: 32px;
      padding-top: 32px;
      font-size: 32px;
      font-family: SF Pro Text-Medium, SF Pro Text;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      //line-height: 80px;
    }
    .index_content {
      margin: 0 auto;
      img {
        margin-top: 40%;
        width: 476px;
        height: 318px;
      }
    }
  }
}
</style>
